// extracted by mini-css-extract-plugin
module.exports = {"container":"_2adcc2af flex-ns flex-row-ns","main":"_7fb5e603","content":"_7cbf6ad7 mw9"};